export enum InmarIssueCode {
  NOT_HEADED_TO_INMAR = "not-headed-to-inmar",
  MISSING_IDS = "missing-ids",
  PENDING_MANUAL_REVIEW = "pending-manual-review",
  NO_SHIPMENTS_PRESENT = "no-shipments-present",
  INTERNAL_ERROR = "internal-error",
}
